import { render, staticRenderFns } from "./r-item-kind-panel.vue?vue&type=template&id=6c2d46ee"
import script from "./r-item-kind-panel.vue?vue&type=script&lang=js"
export * from "./r-item-kind-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2d46ee')) {
      api.createRecord('6c2d46ee', component.options)
    } else {
      api.reload('6c2d46ee', component.options)
    }
    module.hot.accept("./r-item-kind-panel.vue?vue&type=template&id=6c2d46ee", function () {
      api.rerender('6c2d46ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-kind-panel.vue"
export default component.exports